import React from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';

export interface PageShellProps {
  /** Container width preset. */
  width?: 'narrow' | 'default' | 'wide' | 'full';
  /** Sidebar activeClassName — match the existing pattern. */
  sidebarActive?: string;
  /** Optional breadcrumb / page header above the content (whatever JSX). */
  header?: React.ReactNode;
  children: React.ReactNode;
}

const WIDTH_VAR: Record<NonNullable<PageShellProps['width']>, string> = {
  narrow:  'var(--vc-container-narrow)',
  default: 'var(--vc-container)',
  wide:    'var(--vc-container-wide)',
  full:    '100%',
};

/**
 * Standard authenticated-page shell: app header + sidebar + a centred,
 * width-capped content area. Pages just render their content inside; layout
 * and spacing are consistent.
 */
export const PageShell: React.FC<PageShellProps> = ({
  width = 'default',
  sidebarActive,
  header,
  children,
}) => {
  return (
    <div>
      <Header />
      <Sidebar id="menu-item2" id1="menu-items2" activeClassName={sidebarActive} />
      <div className="page-wrapper">
        <div className="content">
          {header && <div className="vc-page-header">{header}</div>}
          <div
            className="vc-page-shell__body"
            style={{ maxWidth: WIDTH_VAR[width] }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
